import { ContactUsFacadeService } from './../../../_app_modules/contact-us/desktop-contact-us/contact-us-facade.service';
import { MatDialog } from '@angular/material/dialog';
import { ResponsiveContactUsDialogComponent } from './responsive-contact-us-dialog.component';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from "@angular/core";

@Component({
    selector: "responsive-contact-us",
    templateUrl: "./responsive-contact-us.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResponsiveContactUsComponent {


  constructor(
    public dialog: MatDialog,
    private readonly contactUsFacadeService: ContactUsFacadeService
  ) {
    this.contactUsFacadeService.showDialog$.subscribe((showDialog) => {
      if (showDialog) {
        this.dialog.open(ResponsiveContactUsDialogComponent, {
          disableClose: true
        });
      } else {
        this.dialog.closeAll();
      }
    });
  }


  openDialog(): void {
    this.contactUsFacadeService.load();
  }

}
